module.exports = __webpack_public_path__ + "static/media/Guía para familiares. Comunidad de Madrid, España, 2014.dcb425c1.pdf";